// extracted by mini-css-extract-plugin
export default {"App":"App_App__w8iei","hw":"App_hw__smXD1","hwTitle":"App_hwTitle__pZCmW"};